import { possibleTime } from 'constants/constants';

export const fromTimeOptions = possibleTime.slice(0, -2).map((e, index) => ({ ...e, index }));
export const toTimeOptions = possibleTime.slice(1).map((e, index) => ({ ...e, index }));
